<template>
  <div
    class="bg-white rounded-xl relative w-full overflow-hidden hover:shadow transition-all duration-300 ease-in-out"
  >
    <div class="relative">
      <div
        class="mb-4 rounded py-1 px-4 absolute top-6 left-3 z-40"
        :class="[
          post.category === 1 ? 'text-white bg-bluegray-500' : '',
          post.category === 2 ? 'bg-bluegray-100 text-black' : '',
          post.category === 3 ? 'bg-black text-white' : '',
        ]"
      >
        <h6>{{ post.category_title }}</h6>
      </div>
      <div v-if="user" class="absolute top-4 right-3 z-50">
        <ManagerPostActionsMenu
          :parent="parent"
          :post_parent="parent + '-' + post.id"
          :status="post.status"
          :post-id="post.cloud_post_id"
        />
      </div>
    </div>

    <!-- Card image -->
    <div
      v-if="post.image_featured"
      :style="{ backgroundImage: 'url(' + post.image_featured + ')' }"
      :class="[post.category === 3 ? 'card-img' : '']"
      class="bg-cover bg-center relative h-48 w-full text-white flex items-center justify-center flex-col"
    >
      <!-- Author info -->
      <div
        v-if="cloud && !author_page"
        class="absolute top-3 right-3 cursor-pointer bg-white rounded-full flex items-center justify-center border-2 border-bluegray-100 w-15 h-15 z-50 authorhello"
        @click="authorModalActive = !authorModalActive"
      >
        <div
          v-if="post.author.logo"
          class="bg-no-repeat bg-cover bg-center w-12 h-12 rounded-full"
          :style="{ backgroundImage: 'url(' + post.author.logo + ')' }"
        ></div>
        <div
          v-else
          class="flex justify-center items-center w-12 h-12 rounded-full text-cw-900"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-12 w-12"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
      </div>
      <!-- Author modal -->
      <div
        :class="[
          authorModalActive
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 pointer-events-none -translate-y-8',
        ]"
        class="w-48 absolute top-24 right-3 rounded bg-white shadow authorInfoModal transform z-50 p-3 space-y-2 transition-all duration-300 ease-in-out"
      >
        <div
          class="bg-white rounded-full flex items-center justify-center border-2 border-bluegray-100 w-12 h-12"
        >
          <div
            v-if="post.author.logo"
            class="bg-no-repeat bg-cover bg-center w-8 h-8 rounded-full"
            :style="{ backgroundImage: 'url(' + post.author.logo + ')' }"
          ></div>
          <div
            v-else
            class="flex justify-center items-center w-8 h-8 rounded-full text-cw-900"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-8 w-8"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>
        <h6
          v-if="post.author.title"
          class="truncate overflow-ellipsis w-40 text-bluegray-500 text-xs"
        >
          {{ post.author.title }}
        </h6>
        <h6 v-if="post.author.post_count" class="text-cw-alt">
          Posts: {{ post.author.post_count }}
        </h6>
        <button
          v-if="post.author.url"
          class="btn btn-cw-300 py-3 px-3"
          @click="showProfile(post.author)"
        >
          View Posts
        </button>
      </div>

      <p
        v-if="post.category === 3 && start_date_short"
        class="text-4xl w-16 text-center font-semibold leading-none z-40"
      >
        {{ start_date_short }}
      </p>
      <a
        v-if="post.category === 3"
        :id="post.id"
        class="z-40 mt-3"
        :class="[cloud ? 'hover:text-cw-alt' : '']"
        @click="viewPost(post.cloud_post_id)"
      >
        View Event ></a
      >
    </div>
    <div
      v-if="!post.image_featured && post.category != 2"
      :style="[
        post.category === 1
          ? { backgroundImage: 'url(/img/default-news.jpg)' }
          : { backgroundImage: 'url(/img/default-event.png)' },
      ]"
      :class="[post.category === 3 ? 'card-img' : '']"
      class="bg-cover bg-center relative h-48 w-full text-white flex items-center justify-center flex-col"
    >
      <!-- Author info -->
      <div
        v-if="cloud && !author_page"
        class="absolute top-3 right-3 cursor-pointer bg-white rounded-full flex items-center justify-center border-2 border-bluegray-100 w-15 h-15 z-50 authorhello"
        @click="authorModalActive = !authorModalActive"
      >
        <div
          v-if="post.author.logo"
          class="bg-no-repeat bg-cover bg-center w-12 h-12 rounded-full"
          :style="{ backgroundImage: 'url(' + post.author.logo + ')' }"
        ></div>
        <div
          v-else
          class="flex justify-center items-center w-12 h-12 rounded-full text-cw-900"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-12 w-12"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
      </div>
      <!-- Author modal -->
      <div
        :class="[
          authorModalActive
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 pointer-events-none -translate-y-8',
        ]"
        class="w-48 absolute top-24 right-3 rounded bg-white shadow authorInfoModal transform z-50 p-3 space-y-2 transition-all duration-300 ease-in-out"
      >
        <div
          class="bg-white rounded-full flex items-center justify-center border-2 border-bluegray-100 w-12 h-12"
        >
          <div
            v-if="post.author.logo"
            class="bg-no-repeat bg-cover bg-center w-8 h-8 rounded-full"
            :style="{ backgroundImage: 'url(' + post.author.logo + ')' }"
          ></div>
          <div
            v-else
            class="flex justify-center items-center w-8 h-8 rounded-full text-cw-900"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-8 w-8"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>
        <h6
          v-if="post.author.title"
          class="truncate overflow-ellipsis w-40 text-bluegray-500 text-xs"
        >
          {{ post.author.title }}
        </h6>
        <h6 v-if="post.author.post_count" class="text-cw-alt">
          Posts: {{ post.author.post_count }}
        </h6>
        <button
          v-if="post.author.url"
          class="btn btn-cw-300 py-3 px-3"
          @click="showProfile(post.author)"
        >
          View Posts
        </button>
      </div>

      <p
        v-if="post.category === 3 && start_date_short"
        class="text-4xl w-24 text-center font-semibold leading-none z-40"
      >
        {{ start_date_short }}
      </p>
      <a
        v-if="post.category === 3"
        :id="post.id"
        class="z-40 mt-3"
        :class="[cloud ? 'hover:text-cw-alt' : '']"
        @click="viewPost(post.cloud_post_id)"
      >
        View Event ></a
      >
    </div>
    <!-- /Card Image -->

    <!-- Card Content -->
    <div class="relative p-6 flex flex-col justify-between">
      <div>
        <div v-if="post.category === 2">
          <!-- Author info -->
          <div
            v-if="cloud && !author_page"
            class="absolute top-3 right-3 cursor-pointer bg-white rounded-full flex items-center justify-center border-2 border-bluegray-100 w-15 h-15 z-50 authorhello"
            @click="authorModalActive = !authorModalActive"
          >
            <div
              v-if="post.author.logo"
              class="bg-no-repeat bg-cover bg-center w-12 h-12 rounded-full"
              :style="{ backgroundImage: 'url(' + post.author.logo + ')' }"
            ></div>
            <div
              v-else
              class="flex justify-center items-center w-12 h-12 rounded-full text-cw-900"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-12 w-12"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
          <!-- Author modal -->
          <div
            :class="[
              authorModalActive
                ? 'opacity-100 translate-y-0'
                : 'opacity-0 pointer-events-none -translate-y-8',
            ]"
            class="w-48 absolute top-24 right-3 rounded bg-white shadow authorInfoModal transform z-50 p-3 space-y-2 transition-all duration-300 ease-in-out"
          >
            <div
              class="bg-white rounded-full flex items-center justify-center border-2 border-bluegray-100 w-12 h-12"
            >
              <div
                v-if="post.author.logo"
                class="bg-no-repeat bg-cover bg-center w-8 h-8 rounded-full"
                :style="{ backgroundImage: 'url(' + post.author.logo + ')' }"
              ></div>
              <div
                v-else
                class="flex justify-center items-center w-8 h-8 rounded-full text-cw-900"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
            <h6
              v-if="post.author.title"
              class="truncate overflow-ellipsis w-40 text-bluegray-500 text-xs"
            >
              {{ post.author.title }}
            </h6>
            <h6 v-if="post.author.post_count" class="text-cw-alt">
              Posts: {{ post.author.post_count }}
            </h6>
            <button
              v-if="post.author.url"
              class="btn btn-cw-300 py-3 px-3"
              @click="showProfile(post.author)"
            >
              View Posts
            </button>
          </div>
        </div>

        <h6
          :class="[cloud ? 'text-cw-700' : 'text-primary']"
          class="uppercase mb-2"
        >
          <template v-if="post.category === 2 && post.job_type">
            <span>{{ jobTypes[post.job_type].text }} </span>
          </template>

          <template v-else-if="post.year_tag && post.year_tag.length">
            <span v-for="(yearTag, index) in post.year_tag">
              <span v-if="index"> | </span>
              {{ yearTag }}
            </span>
          </template>
        </h6>

        <h3>{{ post.title }}</h3>

        <PostTags
          v-if="post.general_tags && post.general_tags.length > 0"
          :tags="post.general_tags"
        />

        <!-- Job Specific -->
        <div v-if="post.category === 2" class="pt-4">
          <p class="pb-4 text-bluegray-400 text-xs">{{ post.description }}</p>
        </div>
        <!-- /Job Specific -->

        <!-- Event Specific -->
        <div
          v-if="post.category === 3"
          class="border-t border-bluegray-300 pt-3 text-xs"
        >
          <!-- Dates -->
          <div
            v-if="post.event_start_at"
            class="mb-2 flex items-center text-bluegray-700"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                clip-rule="evenodd"
              />
            </svg>
            {{ post.event_start_at_ui }}
            <span
              v-if="
                post.event_end_at_ui &&
                post.event_start_at_ui != post.event_end_at_ui
              "
              >- {{ post.event_end_at_ui }}</span
            >
          </div>
          <!-- /Dates -->

          <!-- Venue Title -->
          <div
            v-if="post.event_venue_title"
            class="mb-2 flex items-center text-bluegray-700 text-xs"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                clip-rule="evenodd"
              />
            </svg>
            {{ post.event_venue_title }}
          </div>
          <!-- /Venue Title -->
        </div>
        <!-- /Event specific -->
      </div>

      <!-- Card base -->
      <div
        v-if="post.category != 3"
        class="mt-auto border-t border-bluegray-300 pt-3"
      >
        <h6 class="text-bluegray-400 mb-3">
          Published on {{ post.created_at_ui }}
        </h6>
        <button
          :id="post.id"
          class="z-40 pb-4"
          :class="[cloud ? 'hover:text-cw-alt' : '']"
          @click="viewPost(post.cloud_post_id)"
        >
          View post >
        </button>
      </div>
      <!-- /Card base -->
    </div>
    <!-- /Card Content -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { shared } from '../../../js/mixins/shared.js'
import { JOB_TYPES } from '../../../js/util/constants.js'
import PostTags from '../../../shared/components/PostTags.vue'
import ManagerPostActionsMenu from '../../../shared/tenant/ManagerPostActionsMenu.vue'

export default {
  components: {
    PostTags,
    ManagerPostActionsMenu,
  },

  mixins: { shared },

  props: {
    post: { default: [] },
    cloud: { default: false },
    author_page: { default: false },
    parent: { default: false },
  },

  data() {
    return {
      start_date_short: null,
      end_date_short: null,
      authorModalActive: false,
      jobTypes: JOB_TYPES.slice(0, -2),
    }
  },

  computed: {
    ...mapGetters({
      user: 'shared/getUser',
    }),
  },

  mounted() {
    if (this.post.event_start_at_ui) {
      this.start_date_short = this.post.event_start_at_ui.split(',')[0]
    }

    if (this.post.event_end_at_ui) {
      this.end_date_short = this.post.event_end_at_ui.split(',')[0]
    }
  },

  methods: {
    viewPost(post_id) {
      if (this.cloud) {
        this.$router.push({ path: `/cloudpost/${post_id}` })
      } else {
        this.$router.push({ path: `/post/${post_id}` })
      }
    },

    showProfile(author) {
      if (author.type === 0) {
        this.$router.push({ path: '/organisation/' + author.id })
      } else {
        this.$router.push({ path: '/school/' + author.id })
      }
    },
  },
}
</script>

<style scoped>
.card-img::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
  pointer-events: none;
}

.tag-item::after {
  position: absolute;
  right: -0.5rem;
  top: 50%;
  content: '';
  background: currentColor;
  height: 4px;
  width: 2px;
  border-radius: 6px;
  transform: translateY(-50%);
}

.tag-item:last-child::after {
  opacity: 0;
}

.authorInfoModal:after {
  position: absolute;
  content: '';
  right: 19px;
  top: -10px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 12px 16px 12px;
  border-color: transparent transparent #ffffff transparent;
}
</style>
